import { db } from '../config';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';

export const migrateSublocations = async () => {
  console.log('Starting sublocation migration...');

  try {
    // Get all media documents
    const mediaSnapshot = await getDocs(collection(db, 'site_media'));
    const totalDocs = mediaSnapshot.size;
    let processed = 0;

    console.log(`Found ${totalDocs} media documents to process`);

    // Process each media document
    for (const mediaDoc of mediaSnapshot.docs) {
      const mediaRef = doc(db, 'site_media', mediaDoc.id);
      const mediaData = mediaDoc.data();

      // Only update if document doesn't have sublocation fields yet
      if (!mediaData.subLocationId) {
        await updateDoc(mediaRef, {
          subLocationId: null,
          coordinates: null
        });
      }

      processed++;
      if (processed % 100 === 0 || processed === totalDocs) {
        console.log(`Processed ${processed} of ${totalDocs} documents`);
      }
    }

    console.log('Sublocation migration completed successfully');
  } catch (error) {
    console.error('Error during sublocation migration:', error);
    throw error;
  }
};
